import useSWR, { useSWRConfig, Fetcher } from 'swr';

import { api } from '../../api/api';
import { SWR_KEYS } from './swrKeys';

import { ArtworkItem } from './models';
import { CachedResult } from './interfaces';


export function useArtworks(){

    // Read Logic
    const artworkFetcher: Fetcher<CachedResult<ArtworkItem[]>, string> = async (url: string) => {
        const artworks: ArtworkItem[] = await api.get(url).then((response) => {return response.data;});
        return {
            data: artworks,
            lastUpdated: Date.now()
        };
    }

    const {
        data: artworkData, 
        mutate: mutateArtworks, 
        error, 
        isLoading 
    } = useSWR<CachedResult<ArtworkItem[]>>(SWR_KEYS.ARTWORKS_TITLES, artworkFetcher);

    return {
        artworks: artworkData?.data || [],
        lastUpdated: artworkData?.lastUpdated || undefined,
        isLoading,
        isError: error,
        refreshMainList: mutateArtworks,
    }
}